// To see this message, add the following to the `<head>` section in your
// views/layouts/application.html.erb
//
//    <%= vite_client_tag %>
//    <%= vite_javascript_tag 'application' %>
console.log('Vite ⚡️ Rails')

// If using a TypeScript entrypoint file:
//     <%= vite_typescript_tag 'application' %>
//
// If you want to use .jsx or .tsx, add the extension:
//     <%= vite_javascript_tag 'application.jsx' %>

console.log('Visit the guide for more information: ', 'https://vite-ruby.netlify.app/guide/rails')

// Example: Load Rails libraries in Vite.
//
// import * as Turbo from '@hotwired/turbo'
// Turbo.start()
//
// import ActiveStorage from '@rails/activestorage'
// ActiveStorage.start()
//
// // Import all channels.
// const channels = import.meta.globEager('./**/*_channel.js')

// Example: Import a stylesheet in app/frontend/index.css
// import '~/index.css'

import 'virtual:fonts.css'
import '@hotwired/turbo-rails'

import "@fortawesome/fontawesome-free/css/all.css";
import '../styles/soft-design-system-pro.scss';
import 'material-symbols';

import '@popperjs/core';
import 'bootstrap';
import '../js/soft-design-system-pro/soft-design-system-pro'

import 'lightbox2'
import 'lightbox2/src/css/lightbox.css'

import '../js/jquery'
import '../js/select2'
import 'select2/dist/js/i18n/ru'

import moment from 'moment';
import 'moment/dist/locale/ru';
moment.locale('ru');

import {Application} from '@hotwired/stimulus'
import { registerControllers } from "stimulus-vite-helpers";

const application = Application.start()

const mergedControllers = {
  ...import.meta.glob('../controllers/common/*_controller.{js,ts}', { eager: true }),
  ...import.meta.glob('../controllers/public/*/*_controller.{js,ts}', { eager: true }),
  ...import.meta.glob('../controllers/public/*/*/*_controller.{js,ts}', { eager: true }),
  ...import.meta.glob('../controllers/*_controller.{js,ts}', { eager: true })
};

console.log(JSON.stringify(mergedControllers));
registerControllers(application, mergedControllers);

console.log("Rails + Vite + Stimulus (TypeScript) loaded!")